import { ServiceDetailPage } from '../../components/ServiceDetailPage';
import { SERVICE_DISZLEXIA } from '../../data/content';
import { Helmet } from 'react-helmet-async';

export default function DyslexiaPreventionPage() {
  return (
    <>
      <Helmet>
        <title>Diszlexia Prevenció | Mosolytorna Dunakeszi</title>
        <meta name="description" content="Olvasás- és íráskészség megalapozása, diszlexia prevenciós foglalkozások óvodásoknak és kisiskolásoknak a sikeres iskolakezdésért." />
      </Helmet>
      
      <ServiceDetailPage service={SERVICE_DISZLEXIA} />
    </>
  );
}
